import { MediaModel } from "./MediaModel";
import { api } from "../libs/apis/api";
export var ListType;
(function (ListType) {
    ListType[ListType["listing"] = 0] = "listing";
    ListType[ListType["relatedListing"] = 1] = "relatedListing";
    ListType[ListType["endedListing"] = 2] = "endedListing";
    ListType[ListType["searchListing"] = 3] = "searchListing";
})(ListType || (ListType = {}));
export class MediaListModel {
    constructor(rawData) {
        this._items = [];
        this.parse(rawData);
    }
    parse(rawData) {
        console.log('rawData', rawData);
        this._rawData = rawData;
        if (!this.listingRaw) {
            logger.error('list must have a valid listing');
        }
        this._items = this.listingRaw.items.map(itemRaw => new MediaModel(itemRaw));
    }
    get listingRaw() {
        return MediaListModel.getListingRaw(this._rawData);
    }
    get items() {
        return this._items;
    }
    hasNextLink() {
        return this.listingRaw.links && this.listingRaw.links["api:next"];
    }
    fetchNextLink() {
        if (this.hasNextLink()) {
            return api.get(this.listingRaw.links["api:next"], null, { allowCache: true }).then((result) => {
                const newRawData = this._rawData;
                const newListingRaw = MediaListModel.getListingRaw(newRawData);
                const fetchedListRaw = MediaListModel.getListingRaw(result.body);
                newListingRaw.items = newListingRaw.items.concat(fetchedListRaw.items);
                newListingRaw.links = fetchedListRaw.links;
                newListingRaw.links["api:next"] = fetchedListRaw.links["api:next"];
                newListingRaw.paginator = fetchedListRaw.paginator;
                this.parse(newListingRaw);
            }).catch((e) => {
                logger.error(e);
            });
        }
        return Promise.reject('No next link or already busy');
    }
    get type() {
        return this._type;
    }
    static getListType(rawData) {
        if (rawData.related) {
            return ListType.relatedListing;
        }
        else if (rawData.ended) {
            return ListType.endedListing;
        }
        else if (rawData.search) {
            return ListType.searchListing;
        }
        else {
            return ListType.listing;
        }
    }
    static getListingRaw(listRaw) {
        switch (this.getListType(listRaw)) {
            case ListType.endedListing:
                return listRaw.ended;
            case ListType.relatedListing:
                return listRaw.related;
            case ListType.searchListing:
                return listRaw.search;
        }
        return listRaw;
    }
}
